'use client';
import React from 'react';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import { Box } from '@mui/material';
import cn from './style.module.scss';
interface CommonDynamicHeadingProps {
  label: string;
  elementClassName?: string;
  animationDuration?: number;
}
export default function CommonDynamicHeading({
  label,
  elementClassName,
}: CommonDynamicHeadingProps) {
  return (
    <Box className={`${cn.commonDynamicHeading} ${elementClassName}`}>
      <ParallaxText variant="h2" animationType="zoomIn" animationDuration={500}>
        {ReactHtmlParser(label || '')}
      </ParallaxText>
    </Box>
  );
}
